import { useContext, useEffect, useState } from 'react'
import { Badge } from '../../components/catalyst-component/badge';
import { withTranslation } from 'react-i18next';
import { ArrowRightIcon } from '@heroicons/react/24/solid';
import { BellAlertIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';
import { CompletionsContext, ContactIdContext, LoadingContext } from '../../App';
import { MsalInstanceContext, VariablesContext } from '../../auth/AppProvider';
import { initCompletion } from '../../utils/requests/completions';
import LoadingSpinner from '../../components/Animation/LoadingSpinner';

function NewFormCard({ t, completion, type, filters}) {
    const [countdown, setCountdown] = useState({
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
    });
    let navigate = useNavigate();
    const [completions, setCompletions] = useContext(CompletionsContext);
    const msalInstance = useContext(MsalInstanceContext);
    const variables = useContext(VariablesContext);
    const [loading, setLoading] = useContext(LoadingContext);
    const contactId = useContext(ContactIdContext);
    const [filtersName, setFiltersName] = useState([]);

    useEffect(() => {
        if (filters && filters.length > 0) {
            var filtersName = filters.map(f => {
                var value = completion.properties.hasOwnProperty(f.name) ? completion.properties[f.name] : null;
                if (f.options && f.options.length > 0) {
                    var option = f.options.find(o => o.value === value);
                    if (option) {
                        value = option.label;
                    }
                }
                return { name: f.name, value: value }
            }).filter(f => f.value !== null && f.value !== "" && f.value !== undefined);
            setFiltersName(filtersName);
        }
        if (completion.activationDateTime && completion.activationDateTime.endDate) {
            const time = getTimeRemaining(completion.activationDateTime.endDate);
            setCountdown({
                days: time.days,
                hours: time.hours,
                minutes: time.minutes,
                seconds: time.seconds,
            });
        }
    }, [filters, completion]);


    function getTimeRemaining(date) {
        const time = Date.parse(date) - new Date().getTime(),
            days = Math.floor(time / 1000 / 60 / 60 / 24),
            hours = Math.floor((time / 1000 / 60 / 60) % 24),
            minutes = Math.floor((time / 1000 / 60) % 60),
            seconds = Math.floor((time / 1000) % 60);

        return {
            time,
            days,
            hours,
            minutes,
            seconds,
        };
    }

    function postulate() {
        if (!loading) {
            setLoading(true)
            initCompletion(msalInstance, variables, contactId, completion).then(res => {
                if (res.ok) {
                    return res.json()
                }
            }).then(newCandidature => {
                if (newCandidature) {
                    var completionsLoc = Object.assign([], completions);
                    var index = completionsLoc.findIndex(c => c.id === completion.id)
                    var completionL = newCandidature
                    completionsLoc[index] = completionL
                    setCompletions(completionsLoc)
                    setLoading(false);
                    localStorage.setItem("lastCandidature", JSON.stringify(newCandidature.objectAssociated));
                    navigate("/" + type.name + "/" + completion.id);
                }
            }).catch(err => {
                setLoading(false)
            })
        }
    }

    return (
        <div className="overflow-hidden container-box-b card-btn-slide">
            <div className="" >
                {completion?.activationDateTime?.endDate && countdown.days < 7 ? <div className='text-xs text-bold text-red-500 flex items-center '>
                    <BellAlertIcon className="h-5 w-5 inline-block mr-1 tilt-shaking" />
                    {countdown.days > 0 ?
                        <span className='font-bold'>Plus que {countdown.days} jour{countdown.days > 1 ? "s" : ""} pour remplir le formulaire</span> :
                        countdown.hours > 0 ?
                            <span className='font-bold'>Plus que {countdown.hours}h pour remplir le formulaire</span> :
                            <span className='font-bold'>Plus que {countdown.minutes} minutes pour remplir le formulaire</span>
                    }
                </div> : null}
                <h2 className="font-bold text-gray-900 text-2xl">{completion.label}</h2>
                <div className="mt-2 flex gap-1 text-xs">{filtersName?.map((f, k) => <Badge color="zinc" key={k}>
                    <span className='text-xs'> {f.value}</span>
                </Badge>)}</div>
                {/* <p className="mt-3 my-1 h-8 overflow-hidden text-xs">{completion.parameters?.find(pa => pa.name === "description")?.value}</p> */}
                <div className="flex w-full justify-end bottom-0 left-0 my-3">
                    <div className="flex items-center btn-slide hover:text-white z-10 " >
                        <ArrowRightIcon className="h-8 w-8 rounded-full p-2 mr-2 text-white bg-primary-perso" aria-hidden="true" />
                        <div className="cursor-pointer" style={{ lineHeight: "16px", fontSize: "16px" }} onClick={() => { postulate() }}>
                            {loading ? <LoadingSpinner /> : t("Postuler")}
                        </div></div>
                </div>
            </div>
        </div>
    )
}

export default withTranslation()(NewFormCard);